/**
 * ZoomControls Component
 * L4-ZOOM-008: UI buttons for zoom control
 *
 * Renders +/- buttons in the top-right corner overlay.
 * Minimal, semi-transparent design.
 */

import React from 'react';
import styles from './ZoomControls.module.css';

export interface ZoomControlsProps {
  /** Called when + button is clicked */
  onZoomIn: () => void;
  /** Called when - button is clicked */
  onZoomOut: () => void;
  /** Optional: disable buttons when at limits */
  disableZoomIn?: boolean;
  disableZoomOut?: boolean;
}

/**
 * Zoom control buttons overlay
 */
export function ZoomControls({
  onZoomIn,
  onZoomOut,
  disableZoomIn = false,
  disableZoomOut = false,
}: ZoomControlsProps): JSX.Element {
  return (
    <div className={styles.zoomControls} data-testid="zoom-controls">
      <button
        className={styles.zoomButton}
        onClick={onZoomIn}
        disabled={disableZoomIn}
        aria-label="Zoom in"
        data-testid="zoom-in-button"
      >
        +
      </button>
      <button
        className={styles.zoomButton}
        onClick={onZoomOut}
        disabled={disableZoomOut}
        aria-label="Zoom out"
        data-testid="zoom-out-button"
      >
        −
      </button>
    </div>
  );
}

export default ZoomControls;
